'use client';

import { setPlatformAdapter, type PlatformAdapter } from '@repo/shared';

const webPlatformAdapter: PlatformAdapter = {
  impactOccurred: () => {},
  selectionChanged: () => {},
  notificationOccurred: () => {},
  openLink: (url) => {
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  },
  openTelegramLink: (url) => {
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  },
  showAlert: (message) => {
    if (typeof window !== 'undefined') {
      window.alert(message);
    }
  },
  showConfirm: (message) => {
    if (typeof window === 'undefined') return Promise.resolve(false);
    return Promise.resolve(window.confirm(message));
  },
  openInvoice: (url) => {
    if (typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  },
  close: () => {
    if (typeof window !== 'undefined') {
      window.history.back();
    }
  },
  expand: () => {},
  subscribeViewportChanged: (callback) => {
    if (typeof window === 'undefined' || !window.visualViewport) {
      return () => {};
    }
    window.visualViewport.addEventListener('resize', callback);
    return () => window.visualViewport?.removeEventListener('resize', callback);
  },
  bindBackButton: () => () => {},
};

setPlatformAdapter(webPlatformAdapter);

export {};
